import * as React from 'react';
import { format } from 'sql-formatter'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { 
  DialogContent,
  Box,
} from '@mui/material';
import { CDialog, CDialogTitle, CDialogActions, CButton } from '../components/common/Modal';

export default function QueryModal(props) {
  const {open, query, type, handleClose} = props;
  let queryData = query;
  
  // Ensure queryData is a string
  if (queryData && typeof queryData !== 'string') {
    // If it's an object, try to stringify it or extract a string property
    if (typeof queryData === 'object') {
      queryData = JSON.stringify(queryData, null, 2);
    } else {
      queryData = String(queryData);
    }
  }
  
  if(type === 'oracle' && queryData) {
    try {
      const { gridDefinition: {pov: {members: pov}, columns, rows} } = JSON.parse(queryData);
      const columnMembers = columns.map(item => item.members);
      const rowMembers = rows.map(item => item.members);
      queryData = JSON.stringify({pov, columns: columnMembers, rows: rowMembers}, null, 2);
    } catch (e) {
      // If parsing fails, keep the original queryData
      console.error('Failed to parse Oracle query:', e);
    }
  }

  const formatedSQL = (query) => {
    // Ensure query is a string before formatting
    if (!query || typeof query !== 'string') {
      return query || '';
    }
    try {
      return format(query);
    } catch (e) {
      // If formatting fails, return the original query
      console.error('Failed to format SQL:', e);
      return query;
    }
  }

  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
      >
        <CDialogTitle>SQL Query</CDialogTitle>
        <DialogContent>
          {queryData ? (
            <SyntaxHighlighter language='sql' style={vs}>
              {type === 'oracle' ? queryData : formatedSQL(queryData)}
            </SyntaxHighlighter>
          ) : (
            <Box sx={{ padding: 2, textAlign: 'center', color: 'text.secondary' }}>
              No query available
            </Box>
          )}
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleClose}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}